import { RestClient } from "clients/rest";

export type B000010LoginRequest = {
  shainCd: string;
  password: string;
};

export const B000010Login = (props: B000010LoginRequest) => {
  return RestClient.post("b000010/login", props);
};

export type B000010AuthResponse = {
  shainCd: string;
  shainNm: string;
  shainKana: string;
  taishaYmd: string;
  sakujoyoteiKbn: number;
  eigyoCd: string;
  eigyoNm: string;
  eigyoNmr: string;
  eigyoKana: string;
  bumonCd: string;
  bumonNm: string;
  bumonNmr: string;
  bumonKana: string;
  kengenId: string;
  kengenNm: string;
};

export const B000010Logout = () => {
  return RestClient.get("b000010/logout");
};

export const B000010Auth = () => {
  return RestClient.get<B000010AuthResponse>("b000010/auth", {
    withCredentials: true,
  });
};
